import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
`;

export const DayWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  width: 25px;
  height: 25px;
  background-color: ${({ theme }) => theme.colors.quaternary};
  color: ${({ theme }) => theme.colors.primary};
  ${({ isActive, theme }) =>
    isActive &&
    `
    color: white;
    background-color: ${theme.colors.primary};
  `}
`;
